import React from 'react';

import { ActionTabs } from '../../../helpers/uiComponents/ActionTabs';
import ProfileHeader from '../../../helpers/uiComponents/ProfileHeader';

import { saveBlog } from '../../../data/serviceBlogs';
import { hideMessage, showMessage } from '../../../helpers/uiFunctions/uiActions';
import BlogForm from './BlogForm';
import BlogPreview from './BlogPreview';
import BlogDocumentation from './BlogDocumentation';
import LinkChecker from './BlogLinkChecker';


class Blog extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            currentBlog: []
        }
        this.update = this.update.bind(this);
        this.save = this.save.bind(this);
	}
    componentDidUpdate(prevProps) {
        try {
			if( this.props.currentBlog && (this.props.currentBlog !== prevProps.currentBlog )) {
				var newState = this.props.currentBlog;
			    newState.images = newState.images.sort((a, b) => b.imageId - a.imageId);
                this.setState({
					currentBlog: newState,
				});
			}
		} catch (error) {
			console.log(error);
		}
    }
    save(body) {
        showMessage("Saving Blog...");
        if (!body) {
            body = this.state.currentBlog;
        }
		saveBlog(body).then(data => {
			if (data.success) {
				this.setState({currentBlog: data.result});
                var loadAll = this.props.loadAll;
                loadAll();
			}
            hideMessage(data.success);
		})
	}
    duplicate() {
		var strconfirm = window.confirm("After you duplicate the Article, please be sure to update ALL <img /> tags in the new Article with the updated image HTML. Simply copy and paste the new <img /> tags into the Article and save.");
		if (strconfirm !== true) {
			return;
		}
		let body = this.state.currentBlog;
        body.name = body.name+" - copy";
		delete body.blogId;
		delete body.clientCodes;
		delete body.startDate;
		delete body.images;

		this.save(body);
	}
    update(e) {
        var update = this.state.currentBlog;
		var key = e.target.name;
		var value = e.target.value;
        if (key === "text") {
            value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
            value = value.replace(/"/g, "'");
        }
        update[key] = value;
        this.setState({currentBlog: update});
	}
    tabChange(id) {
		//console.log(id);
		var tabs = document.querySelectorAll(".tabs-wrapper .tab");
		var pages = document.querySelectorAll(".profile-form .tab");
		var i;
		for (i = 0; i < tabs.length; i++) {
			tabs[i].classList.remove("active");
		}
		for (i = 0; i < pages.length; i++) {
			pages[i].classList.remove("active");
		}
		document.querySelectorAll(".tabs-wrapper #tab-"+id)[0].classList.add("active");
		document.querySelectorAll(".profile-form .tab-"+id)[0].classList.add("active");
	}
    render() {
        const { currentBlog } = this.state;
        const clients = this.props.clients;
        const load = this.props.load;
        const tabs = [
            {"id": "1", "name": "Article Settings"},
            {"id": "2", "name": "Article Preview",},
            {"id": "3", "name": "HTML Documentation"},
            {"id": "4", "name": "Link Checker"}
        ]

        return(
            <div className="column profile-column" id="blogs-profile-column">
                {(currentBlog) && (
                    <div className="profile">
                        <React.Fragment>
                            <ProfileHeader
                                name={currentBlog.name}
                                duplicate={() => this.duplicate()}
                            />

                            <div className="profile-form">
                                <div className="input-group">
                                    <div style={{ marginTop: "30px" }}>
                                        <ActionTabs 
                                            handleSave={() => this.save()}
                                            tabs={tabs}
                                            id={"blog"}
                                        />
                                        <div className="inputs" key={currentBlog.blogId} id={"blog-inputs"}>
                                            <BlogForm
                                                update={this.update}
                                                currentBlog={currentBlog}
                                                clients={clients}
                                                load={load}
                                                save={this.save}
                                            />
                                            <BlogPreview currentBlog={currentBlog} />
                                            <BlogDocumentation />
                                            <LinkChecker clients={clients} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    </div>
                )}
            </div>
        )
    }
}
export default Blog;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogProfile/Blog.js